import type { ComponentProps } from 'react';

import type { Breadcrumbs } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core-react/i18n';

import { useLocalPageData } from '#src/app/pages/local/pageContext';

type Result = ModelHookResult<{
	items: ComponentProps<typeof Breadcrumbs>['items'];
}>;

export function useLocalBreadcrumbs(): Result {
	const {
		data: { displayName },
	} = useLocalPageData();
	const { translate } = useI18n();

	return {
		data: {
			items: [
				{ label: translate('corgi.local.breadcrumbs.home'), href: '/' },
				{ label: translate('corgi.local.breadcrumbs.location'), href: '/local?source_location=location-breadcrumb' },
				{ label: displayName },
			],
		},
	};
}
